module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_gartenblick.9177e8c6.jpg";